import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'
import LocalizationService from '@/services/localization-service'

type UpdateBusinessPayload = {
  restaurant_name: string;
  business_type_id: number;
  remove_logo?: 0 | 1;
  logo?: Blob;
}

class BusinessAPIs {
  static async businessTypes() {
    const branchTypes = (await $http.get('/branches-types')).data
    return (branchTypes?.data ?? branchTypes ?? []).map((type: any) => ({
      ...type,
      name: LocalizationService.getTranslate(type, 'name'),
    }))
  }

  static async update(payload: UpdateBusinessPayload) {
    const data = {
      _method: 'PUT',
      ...payload,
    }
    const formData = FormsService.convertObjectToFormData(data)
    const config = { headers: FormsService.MULTIPART_HEADER }
    return (await $http.post('/users/business-info/update', formData, config)).data
  }

  static async updateSettings(payload: any) {
    return (await $http.put('/users/business-info/update-settings', payload)).data
  }

  static async updateSocial(payload: any) {
    return (await $http.put('/users/business-info/update-social', payload)).data
  }

  static async updateReceiptSettings(payload: any) {
    const data = {
      _method: 'PUT',
      ...payload,
    }
    const formData = FormsService.convertObjectToFormData(data)
    const config = { headers: FormsService.MULTIPART_HEADER }
    return (await $http.post('/users/receipt-settings', formData, config)).data
  }

  static async BranchData(reference_id: any) {
    return (await $http.get(`webapp/v5/restaurant/${reference_id}`)).data
  }
}

export default BusinessAPIs
